/**
 * Sale / Sold out pills on color swatches.
 * Uses block-variant-picker JSON (full SellerDash merge) and data-disabled on inputs.
 */
function getSwatchVariantData() {
  const picker = document.querySelector('block-variant-picker');
  if (picker) {
    const embedded = picker.querySelector('script[type="application/json"]');
    if (embedded) {
      try {
        const data = JSON.parse(embedded.textContent);
        if (Array.isArray(data) && data.length) return data;
      } catch (_e) {
        /* fall through */
      }
    }
  }

  const productJsonEl = document.querySelector('script[id^="ProductJson-"]');
  if (!productJsonEl) return [];
  try {
    const product = JSON.parse(productJsonEl.textContent);
    return product?.variants || [];
  } catch (_e) {
    return [];
  }
}

function variantMatchesColor(variant, colorValue) {
  return (
    variant.option1 === colorValue ||
    variant.option2 === colorValue ||
    variant.option3 === colorValue
  );
}

function variantIsPurchasable(variant) {
  if (!variant.available) return false;
  if (
    variant.inventory_management === 'shopify' &&
    typeof variant.inventory_quantity === 'number' &&
    variant.inventory_quantity <= 0 &&
    variant.inventory_policy !== 'continue'
  ) {
    return false;
  }
  return true;
}

function variantOnSale(variant, closeoutColors) {
  const compare = Number(variant.compare_at_price);
  const price = Number(variant.price);
  if (compare > price) return true;
  return closeoutColors.has(variant.option1);
}

function appendSoldOutPill(label) {
  const pill = document.createElement('span');
  pill.className = 'sale-pill sold-out-pill sold-out-pill--on-swatch sale-pill--on-swatch';
  pill.setAttribute('aria-hidden', 'true');
  pill.textContent = 'SOLD OUT';
  label.appendChild(pill);
}

function appendSalePill(label) {
  const pill = document.createElement('span');
  pill.className = 'sale-pill sale-pill--on-swatch';
  pill.setAttribute('aria-hidden', 'true');
  pill.textContent = 'Sale';
  label.appendChild(pill);
}

function updateSwatchStatusPills() {
  const picker = document.querySelector('block-variant-picker');
  if (!picker) return;

  const variantData = getSwatchVariantData();
  const closeoutPipe = picker.getAttribute('data-closeout-colors') || '|';
  const closeoutColors = new Set(
    closeoutPipe
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean)
  );

  picker.querySelectorAll('.variant__button-label[data-color-swatch]').forEach((label) => {
    const colorValue = label.getAttribute('data-option-value');
    if (!colorValue) return;

    label
      .querySelectorAll('.sale-pill--on-swatch, .sold-out-pill--on-swatch')
      .forEach((pill) => pill.remove());

    const inputId = label.getAttribute('for');
    const input = inputId ? document.getElementById(inputId) : null;

    // Theme marks colors with no purchasable variant via data-disabled (SellerDash-safe).
    if (input?.hasAttribute('data-disabled')) {
      appendSoldOutPill(label);
      return;
    }

    const matching = variantData.filter((v) => variantMatchesColor(v, colorValue));

    if (!matching.length) {
      appendSoldOutPill(label);
      return;
    }

    const anyPurchasable = matching.some(variantIsPurchasable);
    const onSale =
      matching.some((v) => variantOnSale(v, closeoutColors)) || closeoutColors.has(colorValue);

    if (!anyPurchasable) {
      appendSoldOutPill(label);
    } else if (onSale) {
      appendSalePill(label);
    }
  });
}

function scheduleSwatchStatusPills() {
  updateSwatchStatusPills();
  [0, 100, 300, 800, 1500, 2500].forEach((ms) => setTimeout(updateSwatchStatusPills, ms));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleSwatchStatusPills);
} else {
  scheduleSwatchStatusPills();
}

document.addEventListener('shopify:section:load', scheduleSwatchStatusPills);
